import React, { forwardRef, ReactNode } from 'react';
import { MenuGroup, MenuListProps } from '@chakra-ui/react';

interface Props extends Omit<MenuListProps, `css`> {
  children: ReactNode;
}

export const DropdownListGroup = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <MenuGroup ref={ref} {...props}>
        {children}
      </MenuGroup>
    );
  }
);
export type { Props as DropdownListProps };
